/**
 * Gets today's date in DD-MM-YYYY format.
 */
export const getTodayDateInputString = () => {
  const mindate = new Date();
  const day = ("0" + mindate.getDate()).slice(-2);
  const month = ("0" + (mindate.getMonth() + 1)).slice(-2);
  const year = mindate.getFullYear();
  return `${year}-${month}-${day}`;
};

/**
 * Strips email domain to get a username.
 */
export const getSafeUsername = (email) => {
  if (!email) return "";
  return email.split("@")[0];
};

/**
 * Validates if a date string is today or in the future.
 */
export const isDateTodayOrFuture = (dateStr) => {
  if (!dateStr) return false;
  const itemDate = new Date(dateStr);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  itemDate.setHours(0, 0, 0, 0);
  return itemDate >= today;
};
